import { render } from "./1_mina.vue?vue&type=template&id=c0b18664&scoped=true"
import script from "./1_mina.vue?vue&type=script&lang=js"
export * from "./1_mina.vue?vue&type=script&lang=js"

import "./1_mina.vue?vue&type=style&index=0&id=c0b18664&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0b18664"]])

export default __exports__